<template>
  <!-- Blog  Section -->
  <section class="blog-section">
    <div class="container">
      <div class="row aos" data-aos="fade-up">
        <div class="col-lg-12">
          <div class="home-six-heading-section">
            <div
              class="home-six-title d-flex justify-content-center align-items-center"
            >
              <h2>News & Information</h2>
              <img src="@/assets/img/icons/title.svg" alt="" />
            </div>
            <p>
              Rutrum ante tempus mauris facilisi, leo faucibus, egestas
              diamlorem malesu, vitae mauris.
            </p>
          </div>
        </div>
      </div>
      <div class="row aos" data-aos="fade-up" data-aos-delay="200">
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
          <div class="blog grid-blog">
            <div class="blog-image">
              <router-link to="blog-details"
                ><img
                  class="img-fluid"
                  src="@/assets/img/blog/blog-six-1.png"
                  alt="Post Image"
              /></router-link>
            </div>
            <div class="blog-content">
              <p class="blog-category">
                <a href="javascript:void(0);"><span>Health</span></a
                ><a href="javascript:void(0);"><span>Care</span></a>
              </p>
              <ul class="entry-meta meta-item">
                <li>
                  <div class="post-author">
                    <div class="post-author-img">
                      <img
                        src="@/assets/img/profiles/avatar-14.jpg"
                        alt="Post Author"
                      />
                    </div>
                    <a href="javascript:void(0);" class="mb-0">
                      <span> Amara </span></a
                    >
                  </div>
                </li>
                <li class="date-icon">
                  <i class="fa-solid fa-calendar-days"></i> October 4, 2023
                </li>
              </ul>
              <h3 class="blog-title">
                <router-link to="blog-details"
                  >Three Powerful Tricks for Online Advertising</router-link
                >
              </h3>
              <p class="blog-description">
                Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed
                do eiusmod tempor. Lorem ipsum dolor sit amet, consectetur em
                adipiscing elit,
              </p>
              <p class="viewlink">
                <router-link to="blog-details"
                  >View Details <i class="feather-arrow-right"></i
                ></router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
          <div class="blog grid-blog">
            <div class="blog-image">
              <router-link to="blog-details"
                ><img
                  class="img-fluid"
                  src="@/assets/img/blog/blog-six-2.png"
                  alt="Post Image"
              /></router-link>
            </div>
            <div class="blog-content">
              <p class="blog-category">
                <a href="javascript:void(0);"><span>Care & Tips</span></a>
              </p>
              <ul class="entry-meta meta-item">
                <li>
                  <div class="post-author">
                    <div class="post-author-img">
                      <img
                        src="@/assets/img/profiles/avatar-12.jpg"
                        alt="Post Author"
                      />
                    </div>
                    <a href="javascript:void(0);" class="mb-0"
                      ><span> Darryl </span></a
                    >
                  </div>
                </li>
                <li class="date-icon">
                  <i class="fa-solid fa-calendar-days"></i> October 6, 2023
                </li>
              </ul>
              <h3 class="blog-title">
                <router-link to="blog-details"
                  >Three Powerful Tricks For Online Advertising</router-link
                >
              </h3>
              <p class="blog-description">
                Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed
                do eiusmod tempor. Lorem ipsum dolor sit amet, consectetur em
                adipiscing elit,
              </p>
              <p class="viewlink">
                <router-link to="blog-details"
                  >View Details <i class="feather-arrow-right"></i
                ></router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
          <div class="blog grid-blog">
            <div class="blog-image">
              <router-link to="blog-details"
                ><img
                  class="img-fluid"
                  src="@/assets/img/blog/blog-six-3.png"
                  alt="Post Image"
              /></router-link>
            </div>
            <div class="blog-content">
              <p class="blog-category">
                <a href="javascript:void(0);"><span>Health</span></a
                ><a href="javascript:void(0);"><span>Care</span></a>
              </p>
              <ul class="entry-meta meta-item">
                <li>
                  <div class="post-author">
                    <div class="post-author-img">
                      <img
                        src="@/assets/img/profiles/avatar-13.jpg"
                        alt="Post Author"
                      />
                    </div>
                    <a href="javascript:void(0);" class="mb-0">
                      <span> Mary </span></a
                    >
                  </div>
                </li>
                <li class="date-icon">
                  <i class="fa-solid fa-calendar-days"></i> October 10, 2023
                </li>
              </ul>
              <h3 class="blog-title">
                <router-link to="blog-details"
                  >Competitive Analysis for Enterprerneurs in 20232</router-link
                >
              </h3>
              <p class="blog-description">
                Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed
                do eiusmod tempor. Lorem ipsum dolor sit amet, consectetur em
                adipiscing elit,
              </p>
              <p class="viewlink">
                <router-link to="blog-details"
                  >View Details <i class="feather-arrow-right"></i
                ></router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-12 d-flex justify-content-center align-items-center">
          <div class="car-more-blog">
            <router-link to="blog-list">More Blog</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Blog  Section -->

  <!-- Join Us -->
  <section class="join-us-dealer">
    <div class="join-us-dealer-bg">
      <img src="@/assets/img/become-dealer-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="row align-items-center aos" data-aos="fade-up">
        <div class="col-lg-6 col-md-12">
          <div class="joinus-dealer-content">
            <h3 class="aos" data-aos="fade-up" data-aos-delay="200">
              Become a Dealer with Listee?
            </h3>
            <p class="aos" data-aos="fade-up" data-aos-delay="300">
              Sell your car Free with Listee and earn commision up to 70%.
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="join-as-dealer-btn">
            <router-link to="signup"
              >Create an Account <i class="feather-arrow-right ms-2"></i
            ></router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Join Us -->
</template>
